import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=d3e42cc8&scoped=true&"
import script from "./Election.vue?vue&type=script&lang=js&"
export * from "./Election.vue?vue&type=script&lang=js&"
import style0 from "./Election.vue?vue&type=style&index=0&id=d3e42cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e42cc8",
  null
  
)

export default component.exports